<template>
  <div :class="['upload-attachment-item', extraClasses, { [loadingClasses]: loading }]">
    <div v-if="showPreview && attachment">
      <image-preview
          extraClasses="thumbnail-label"
          :description="uploadConfig.differentLabel || uploadConfig.displayType"
          :deleteClasses="deleteClasses"
          :deleteText="deleteText"
          :uuid="attachment.uuid"
          :src="attachment.thumb"
          @reload="reload">
      </image-preview>
    </div>

    <modal v-if="showModal"
           showClose
           wrapperClasses="ad-alert-modal"
           @close="showModal = false">
      <div slot="body" class="resize-warning body">
        <p>attention! in order to ensure the best image quality, images must be uploaded with a max of 5MB (file size) and in an acceptable image format which includes GIF, JPEG and PNG. </p>
      </div>
    </modal>

    <loading-icon v-if="loading" :loadingIconClasses="loadingClasses"></loading-icon>
    <div v-if="showInputFile && !loading" :class="['attachment-upload', fileUploadClasses]">
      <label class="attachment-label" :for="uploadConfig.displayType" :name="uploadConfig.displayType">
        <span>{{uploadConfig.differentLabel || uploadConfig.displayType}}</span>
        <div v-if="uploadConfig.uploadIcon" class="attachment-upload-icon">
          <svg :viewBox="uploadConfig.uploadIconViewbox" class="sb-icon">
            <use :xlink:href="'#'+uploadConfig.uploadIcon"></use>
          </svg>
        </div>
        <span>{{uploadConfig.differentLabelBelow}}</span>
      </label>
      <input
          accept="image/png,image/gif,image/jpeg"
          class="hide"
          :id="uploadConfig.displayType"
          ref="attachmentUpload"
          type="file"
          @change="processUpload"
          :name="uploadConfig.displayType" />
      <span v-if="uploadConfig.instructions" class="upload-instructions">{{uploadConfig.instructions}}</span>
      <small v-if="errorMessage || errorDisplayImage" class='file-warning error-label form-message'>{{errorMessage || errorDisplayImage}}</small>
    </div>
  </div>
</template>

<script>
  import CreateAttachmentMixin from '../../mixins/CreateAttachmentMixin'
  import ImagePreview from '../shared/ImagePreview'
  import Modal from '../shared/Modal'
  import { isObject } from '../../utilities/index'
  import LoadingIcon from '../shared/LoadingIcon'
  import { mapState } from 'vuex'

  export default {
    props: {
      attachment: Object,
      attachmentType: {
        default: 'image',
        type: String
      },
      deleteClasses: String,
      deleteText: String,
      errorDisplayImage: String,
      extraClasses: String,
      fileUploadClasses: String,
      label: String,
      loadingClasses: String,
      ownerId: [Number, String],
      ownerType: String,
      showInputFile: Boolean,
      showPreview: Boolean,
      showPreviewModal: Boolean,
      uploadConfig: Object,
    },

    name: 'UploadAttachment',

    components: {
      ImagePreview,
      LoadingIcon,
      Modal
    },

    mixins: [CreateAttachmentMixin],

    data() {
      return {
        errorMessage: null,
        onlyImages: ['image/png','image/gif','image/jpeg'],
        imageFile: null,
        loading: false,
        maxAttachmentSize: 1024 * 1024 * 10, // 10 mb
        showModal: false
      };
    },

    methods: {
      clearFile() {
        const $file = this.$refs.attachmentUpload
        $file && ($file.value = null)
      },

      configureCreatedAttachment(data, errors) {
        const validWithoutErrors = isObject(data) && !errors
        if (validWithoutErrors) {
          this.errorMessage = null
          this.$emit('setImageLink', data)
          this.$emit('reloadAttachments')
          this.$emit('configureAttachment', data)
        } else if (errors) {
          this.errorMessage = `issue uploading ${this.attachmentType}: ${errors}`
        } else {
          this.errorMessage = `error uploading ${this.attachmentType}, no data found`
        }
        !validWithoutErrors && this.$emit('close')
        this.loading = false
      },

      processUpload(event) {
        const file = event.target.files[0]
        if (!file) { return this.errorMessage = null }
        this.imageFile = file
        this.uploadAttachment()
      },

      reload() {
        this.$emit('reloadAttachments')
      },

      setAttachmentErrors(errorMessage) {
        this.loading = false
        this.errorMessage = errorMessage || null
      },

      showModalAndClearFile() {
        this.showModal = true
        this.clearFile()
      },

      uploadAttachment() {
        let formData = new FormData()
        formData.append('file', this.imageFile)
        formData.append('label', this.label)
        formData.append('owner_type', this.ownerType)
        formData.append('owner_id', this.ownerId)
        this.loading = true
        this.createAttachment(formData, this.configureCreatedAttachment, this.setAttachmentErrors)
      },

      validateAttachment() {
        const isAllowed = this.uploadConfig.anyAttachment || this.onlyImages.includes(this.imageFile.type)
        if (this.imageFile.size < this.maxAttachmentSize) {
          if (!isAllowed) { return this.errorMessage = `only ${this.attachmentType}s can be uploaded` }
          this.uploadAttachment()
        } else {
          this.errorMessage = `${this.attachmentType} too large, select an image under 10 MB`
          this.clearFile()
        }
      },

      validateMmsImages() {
        const view = this
        let img = new Image()
        img.onload = function() {
          const validType = view.onlyImages.includes(view.imageFile.type),
                validSize = view.imageFile.size <= view.maxMediaSize,
                isValidSizeAndType = validType && validSize,
                canBeUploaded = isValidSizeAndType

          if (canBeUploaded) {
            view.uploadAttachment()
            view.$emit('showPreviewModal', view.imageFile, !validSize)
          } else {
            view.showModalAndClearFile()
          }
        }
        img.onerror = (e) => {
          view.showModalAndClearFile()
        }
        img.src = URL.createObjectURL(this.imageFile)
      },
    },

    computed: {
      ...mapState([
        'maxMmsImageSize',
        'maxMediaSize',
        'maxMmsImageResizeWidth'
      ])
    },

    watch: {
      loading: function () {
        this.$emit('adviseLoading', this.loading)
      }
    },
  }
</script>
